/**
 * Endpoint methods related to Customers
*/

import API from "./Api";

export default {

  async updateOrCreate(form) {
    return API.post(`customersettings/updateorcreate`, form, "MOODLE_SESSION_JSON");
  },

};
